import { useState } from "react";
import { toast } from "sonner";
import { useSeo } from "@/hooks/useSeo";

export default function Contact() {
  useSeo({
    title: "Contact",
    description: "Contactez l'équipe R-1.immo. Une question, un projet, un lieu atypique à valoriser ? Écrivez-nous — 15 rue du Sous-Sol, 75011 Paris.",
    path: "/contact",
  });
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("Message envoyé — nous revenons vers vous rapidement");
    setForm({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="px-6 md:px-12 lg:px-16 py-16">
      <div className="max-w-2xl">
        <div className="label-mono mb-4 text-amber-500">§ contact</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter mb-8">Parlons de votre lieu.</h1>
        <p className="text-zinc-400 mb-12">Une question, un projet particulier, un lieu complexe à valoriser ? Écrivez-nous.</p>

        <form onSubmit={submit} className="space-y-4 border border-zinc-800 bg-zinc-950 p-8">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <div className="label-mono mb-2">Nom</div>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-page-name" className="w-full bg-zinc-900 border border-zinc-800 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500" />
            </div>
            <div>
              <div className="label-mono mb-2">Email</div>
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-page-email" className="w-full bg-zinc-900 border border-zinc-800 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500" />
            </div>
          </div>
          <div>
            <div className="label-mono mb-2">Sujet</div>
            <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full bg-zinc-900 border border-zinc-800 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500" />
          </div>
          <div>
            <div className="label-mono mb-2">Message</div>
            <textarea required rows="6" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-page-message" className="w-full bg-zinc-900 border border-zinc-800 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500" />
          </div>
          <button data-testid="contact-page-submit" className="bg-amber-500 hover:bg-amber-400 text-black px-6 py-3 text-xs uppercase tracking-widest">Envoyer</button>
        </form>

        <div className="mt-12 grid md:grid-cols-3 gap-6 label-mono text-zinc-500">
          <div>
            <div className="text-amber-500 mb-1">EMAIL</div>
            <div>contact@r-1.immo</div>
          </div>
          <div>
            <div className="text-amber-500 mb-1">TEL</div>
            <div>+33 1 88 88 88 88</div>
          </div>
          <div>
            <div className="text-amber-500 mb-1">ADRESSE</div>
            <div>15 rue du Sous-Sol<br />75011 Paris</div>
          </div>
        </div>
      </div>
    </div>
  );
}
